module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Ingenbohl-5c7eb32345b24ffcd5700b17391f99c9.png";